/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const usageDailySeriesSchema = z.object({
  voiceId: z.string(),
  voiceLabel: z.string(),
  partLabel: z.enum(['title', 'definition', 'usageNotes', 'examples', 'other']),
  daily: z.array(z.number()),
});

export const elevenlabsUsageDailyV1DataSchema = z.object({
  dates: z.array(z.string()),
  series: z.array(usageDailySeriesSchema),
  totalChars: z.number(),
});

export type IElevenlabsUsageDailyV1Data = z.infer<typeof elevenlabsUsageDailyV1DataSchema>;
export type IElevenlabsUsageDailySeries = z.infer<typeof usageDailySeriesSchema>;

export const getElevenlabsUsageDailyV1ResponseSchema = createApiResponseSchema(
  elevenlabsUsageDailyV1DataSchema,
) as z.ZodSchema<IAPI<IElevenlabsUsageDailyV1Data>>;

export type IGetElevenlabsUsageDailyV1Response = IAPI<IElevenlabsUsageDailyV1Data>;
